import { Pipe, PipeTransform } from '@angular/core';
import { AuthError } from '@angular/fire/auth';
import { getFirebaseErrorTranslation } from 'src/app/state/auth';

@Pipe({
  name: 'firebaseError'
})
export class FirebaseErrorPipe implements PipeTransform {

  transform(value: AuthError): string {
    return getFirebaseErrorTranslation(value);
  }
}
